import { render } from "./simpeg-naikpangkat-prediksi-list.vue?vue&type=template&id=b65ae794"
import script from "./simpeg-naikpangkat-prediksi-list.vue?vue&type=script&lang=js"
export * from "./simpeg-naikpangkat-prediksi-list.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__